module.exports = __webpack_public_path__ + "static/vlp-logo-4cf9842e98c7def881f465b6a1cbdf54.png";